import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isLoggedIn } from "../Localstorage";
import { useAccessCard } from "../ContextProvider/Accesscardprovider";

const Privateroute = () => {
    const { accessCard, accessCallReg } = useAccessCard();

    useEffect(() => {
        if (!isLoggedIn()) {
            accessCard(); 
            accessCallReg();
        }
    }, []);

    return isLoggedIn() ? <Outlet /> : <Navigate to={"/"} />;
};

export default Privateroute;
